export const date_format = 'YYYY-MM-DDTHH:mm:ss.SSSZ'

export const date_format_short = 'YYYY-MM-DD'
